import { render, staticRenderFns } from "./WeeksPoints.vue?vue&type=template&id=3056af31&"
import script from "./WeeksPoints.vue?vue&type=script&lang=js&"
export * from "./WeeksPoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports